function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';

var SearchResultComponent = function (_React$Component) {
  _inherits(SearchResultComponent, _React$Component);

  function SearchResultComponent() {
    _classCallCheck(this, SearchResultComponent);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  SearchResultComponent.prototype.render = function render() {
    var _props = this.props,
        result = _props.result,
        onResultSelected = _props.onResultSelected;
    return React.createElement('li', {
      key: result.id,
      className: 'clearfix',
      onClick: function onClick() {
        return onResultSelected(result);
      },
      onMouseOver: function onMouseOver() {
        return result.olFeature && result.olFeature.set('hover', true);
      },
      onMouseOut: function onMouseOut() {
        return result.olFeature && result.olFeature.set('hover', false);
      }
    }, React.createElement('h3', null, result.properties.title), result.properties.content && React.createElement('p', {
      className: 'searchSource--content'
    }, result.properties.content.replace(/<.*?>/g, '').substring(0, 150)), React.createElement('p', {
      className: 'searchSource--provider'
    }, result.properties.provider));
  };

  return SearchResultComponent;
}(React.Component);

export default SearchResultComponent;